/**
 * /certificacao-bkp — backup do catálogo de certificações FORA de ação.
 *
 * Mantido navegável (noindex) para conferência durante as ações promocionais,
 * quando /certificacao passa a exibir a oferta da campanha.
 */
import { createFileRoute } from "@tanstack/react-router";

import { CertificacaoCatalogo, TITLE } from "@/components/lps/CertificacaoCatalogoPage";

export const Route = createFileRoute("/certificacao-bkp")({
  head: () => ({
    meta: [
      { title: `${TITLE} (backup)` },
      { name: "description", content: "Versão de backup do catálogo das Certificações FEO, sem oferta de campanha." },
      { property: "og:title", content: `${TITLE} (backup)` },
      { property: "og:description", content: "Catálogo das Certificações FEO fora de ação promocional." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => <CertificacaoCatalogo />,
});
